import { jsx as i, jsxs as x, Fragment as j } from "react/jsx-runtime";
import { forwardRef as L, useState as T, useEffect as H, useMemo as pt, useRef as U, Fragment as Ot, useImperativeHandle as Lt, useCallback as nt } from "react";
import { styled as p, Box as v, Button as gt, CircularProgress as _, TextField as ft, InputAdornment as Y, IconButton as O, Tooltip as W, Select as Wt, MenuItem as mt, FormControl as Et, InputLabel as Ht, FormHelperText as ht, ToggleButtonGroup as _t, Menu as Pt, MenuList as Gt, Checkbox as q, Link as jt, ListItemText as bt, Autocomplete as z, Divider as G, ListItemIcon as Vt, createFilterOptions as Nt, Accordion as Ut, AccordionSummary as Yt, AccordionDetails as qt, Avatar as zt, Snackbar as Zt, Portal as Jt, Fade as Xt, Slide as xt, alpha as Kt, useTheme as V, Toolbar as Qt, AppBar as te, Paper as ee, Dialog as ne, DialogTitle as oe, Chip as ie, DialogContent as re, DialogActions as ae } from "@mui/material";
import { T as B, c as P, u as $, N as ot, A as le } from "../TablePaginationActions-EC4ynZRa.js";
import { a as _o } from "../TablePaginationActions-EC4ynZRa.js";
import { useIntl as R } from "react-intl";
import { VisibilityOffOutlined as ce, VisibilityOutlined as se, Cancel as yt, AddCircleOutlineOutlined as de, CloseOutlined as Mt, MenuOutlined as ue, HelpOutline as Z, TodayOutlined as pe, Check as ge } from "@mui/icons-material";
import { A as Ct } from "../Alert-Cn0nq6aq.js";
import "cartocolor";
import { M as vt } from "../MenuItem-vbfSlKyV.js";
import { A as J } from "../ArrowDown-B1AG0MlL.js";
import { DatePicker as fe } from "@mui/x-date-pickers/DatePicker";
import { PickersDay as me } from "@mui/x-date-pickers";
import { TimePicker as he } from "@mui/x-date-pickers/TimePicker";
import { DateTimePicker as be } from "@mui/x-date-pickers/DateTimePicker";
import xe from "@mui/material/ClickAwayListener";
const ye = p(v)({
  position: "absolute",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  display: "flex",
  alignItems: "center",
  justifyContent: "center"
}), Me = p(v)({
  visibility: "hidden",
  pointerEvents: "none"
});
function Ce({
  children: t,
  loading: e,
  disabled: n,
  startIcon: o,
  endIcon: r,
  loadingPosition: a,
  ...l
}, c) {
  const s = /* @__PURE__ */ i(_, { size: 18, color: "inherit" }), d = e && a === void 0, h = () => d ? /* @__PURE__ */ x(v, { sx: { position: "relative" }, children: [
    /* @__PURE__ */ i(ye, { children: s }),
    /* @__PURE__ */ i(Me, { children: t })
  ] }) : t, u = (g) => {
    if (!d)
      return e && a !== void 0 ? a === g ? s : void 0 : g === "start" ? o : r;
  };
  return /* @__PURE__ */ i(
    gt,
    {
      disabled: e || n,
      startIcon: u("start"),
      endIcon: u("end"),
      ...l,
      ref: c,
      children: /* @__PURE__ */ i(B, { variant: "inherit", color: "inherit", noWrap: !0, component: "span", children: h() })
    }
  );
}
const go = L(Ce), ve = p(v)(({ theme: t }) => ({
  display: "flex",
  alignItems: "center",
  gap: t.spacing(0.5)
})), De = p(B)(({ theme: t }) => ({
  ".Mui-disabled &": {
    color: t.palette.text.disabled
  }
})), Ae = p(v)(({ theme: t }) => ({
  display: "flex",
  svg: {
    width: P,
    height: P,
    fontSize: P,
    path: {
      fill: t.palette.text.secondary,
      ".Mui-disabled &": {
        fill: t.palette.text.disabled
      }
    }
  }
}));
function X({
  label: t,
  type: e,
  icon: n,
  inheritSize: o
}) {
  return /* @__PURE__ */ x(ve, { children: [
    t,
    e && /* @__PURE__ */ i(
      De,
      {
        component: "span",
        variant: o ? "inherit" : "caption",
        color: "textSecondary",
        weight: "regular",
        children: e === "required" ? "(required)" : "(optional)"
      }
    ),
    n && /* @__PURE__ */ i(Ae, { children: n })
  ] });
}
function ke({ InputProps: t, size: e = "small", ...n }, o) {
  const r = R(), a = $(r), [l, c] = T(!1);
  return /* @__PURE__ */ i(
    ft,
    {
      ...n,
      ref: o,
      type: l ? "text" : "password",
      size: e,
      InputProps: {
        ...t,
        endAdornment: /* @__PURE__ */ i(Y, { position: "end", children: /* @__PURE__ */ i(O, { size: e, onClick: () => c(!l), children: /* @__PURE__ */ i(
          W,
          {
            title: a.formatMessage({
              id: `c4r.form.${l ? "hidePassword" : "showPassword"}`
            }),
            children: l ? /* @__PURE__ */ i(ce, {}) : /* @__PURE__ */ i(se, {})
          }
        ) }) })
      }
    }
  );
}
const fo = L(ke), N = {};
function Ie(t = "$lodash$") {
  N[t] || (N[t] = 0);
  const e = ++N[t];
  return t === "$lodash$" ? `${e}` : `${t}${e}`;
}
const we = p(Wt)(({ theme: t }) => ({
  "& .MuiInputAdornment-positionStart": {
    paddingLeft: t.spacing(2),
    "&.MuiInputAdornment-sizeSmall": {
      paddingLeft: t.spacing(1.5)
    }
  },
  "& .MuiInputBase-inputAdornedStart": {
    paddingLeft: "0px !important"
  },
  "& .MuiSelect-select .MuiMenuItem-root:hover": {
    backgroundColor: "transparent"
  },
  "&.MuiInputBase-root .MuiSelect-select.MuiSelect-multiple": {
    paddingRight: t.spacing(7)
  }
})), Be = p(mt)(() => ({
  display: "none"
}));
function Se({
  children: t,
  placeholder: e,
  size: n = "small",
  displayEmpty: o,
  menuProps: r,
  inputProps: a,
  labelId: l,
  label: c,
  labelSecondary: s,
  helperText: d,
  name: h,
  error: u,
  focused: g,
  disabled: f,
  fullWidth: m,
  required: y,
  "aria-label": b,
  ...D
}, w) {
  const A = n === "small", [M] = T(() => Ie("select-label-")), k = c ? l ?? M : void 0;
  return /* @__PURE__ */ x(
    Et,
    {
      size: n,
      error: u,
      focused: g,
      disabled: f,
      fullWidth: m,
      required: y,
      children: [
        /* @__PURE__ */ x(v, { display: "flex", alignItems: "center", justifyContent: "space-between", children: [
          c && /* @__PURE__ */ i(Ht, { shrink: !0, id: k, children: c }),
          s && /* @__PURE__ */ i(v, { display: "flex", alignItems: "center", ml: 2, mb: 0.5, children: s })
        ] }),
        /* @__PURE__ */ x(
          we,
          {
            ...D,
            labelId: k,
            name: h,
            ref: w,
            size: n,
            fullWidth: m,
            displayEmpty: o ?? !!e,
            inputProps: {
              ...a,
              "aria-label": b
            },
            MenuProps: {
              ...r,
              PopoverClasses: {
                paper: A ? "MuiMenu-paper-sizeSmall" : void 0
              },
              anchorOrigin: {
                vertical: "bottom",
                horizontal: "left"
              },
              transformOrigin: {
                vertical: 0,
                horizontal: "left"
              }
            },
            children: [
              e && /* @__PURE__ */ i(Be, { disabled: !0, value: "", children: /* @__PURE__ */ i(
                B,
                {
                  variant: A ? "body2" : "body1",
                  color: "text.hint",
                  component: "span",
                  children: e
                }
              ) }),
              t
            ]
          }
        ),
        d && /* @__PURE__ */ i(ht, { "aria-label": `${h}-helper`, children: d })
      ]
    }
  );
}
const Te = L(Se), $e = p(_t, {
  shouldForwardProp: (t) => t !== "variant" && t !== "backgroundColor"
})(({ variant: t, backgroundColor: e, theme: n }) => ({
  // Variants
  ...t === "contained" && {
    boxShadow: "none"
  },
  ...t === "unbounded" && {
    boxShadow: "none",
    borderRadius: n.spacing(0.5),
    "& .MuiDivider-root": {
      height: n.spacing(4),
      "&.MuiToggleButtonGroup-groupedHorizontal": {
        height: n.spacing(4)
      },
      "&.MuiToggleButtonGroup-groupedVertical": {
        height: "auto",
        width: n.spacing(4),
        margin: `${n.spacing(0.5, 0, 1)} !important`,
        borderRadius: "0 !important"
      }
    },
    "& .MuiToggleButton-sizeSmall": {
      margin: 0,
      "&.MuiToggleButtonGroup-grouped:not(.MuiDivider-root)": {
        margin: 0
      },
      "& + .MuiDivider-root.MuiToggleButtonGroup-groupedHorizontal": {
        height: n.spacing(3)
      },
      "& + .MuiDivider-root.MuiToggleButtonGroup-groupedVertical": {
        height: "auto",
        width: n.spacing(3)
      }
    },
    ".MuiToggleButtonGroup-grouped:not(.MuiDivider-root)": {
      margin: 0,
      "&:first-of-type": {
        marginLeft: 0
      },
      "&:not(:last-of-type)": {
        marginRight: n.spacing(0.5)
      }
    },
    "&.MuiToggleButtonGroup-horizontal:not(.MuiDivider-root)": {
      ".MuiToggleButtonGroup-grouped": {
        margin: n.spacing(0, 0.5)
      }
    },
    "&.MuiToggleButtonGroup-vertical:not(.MuiDivider-root)": {
      ".MuiToggleButtonGroup-grouped": {
        margin: n.spacing(0, 0, 0.5),
        "&:not(:last-of-type)": {
          marginRight: 0
        },
        "&:last-of-type": {
          marginBottom: 0
        }
      }
    }
  },
  // Colors
  ...e === "primary" && {
    backgroundColor: n.palette.background.paper
  },
  ...e === "secondary" && {
    backgroundColor: n.palette.background.default
  },
  ...e === "transparent" && {
    backgroundColor: "transparent"
  }
}));
function mo({
  children: t,
  variant: e = "floating",
  backgroundColor: n,
  ...o
}) {
  return /* @__PURE__ */ i(
    $e,
    {
      ...o,
      variant: e,
      backgroundColor: n ?? (e === "unbounded" ? "transparent" : "primary"),
      children: t
    }
  );
}
const Re = p("div")(({ theme: t }) => ({
  position: "relative",
  display: "inline-flex",
  // TODO: Remove this once we have a better way to handle the spacing between icon buttons:
  // https://app.shortcut.com/cartoteam/story/471284/create-iconbuttongroup-component-to-properly-group-several-icons
  "& + &, & + .optionIconButton": {
    marginLeft: t.spacing(0.5)
  }
})), Fe = p(O, {
  shouldForwardProp: (t) => !["active"].includes(t)
})(({ active: t, theme: e }) => ({
  ...t && {
    color: e.palette.primary.main,
    backgroundColor: e.palette.primary.background,
    "& svg:not(.doNotFillIcon) path": {
      fill: e.palette.primary.main
    }
  }
}));
function Oe({
  tooltip: t,
  tooltipPlacement: e = "top",
  icon: n,
  size: o = "medium",
  variant: r = "icon",
  color: a = "default",
  sx: l,
  className: c,
  loading: s,
  disabled: d,
  active: h,
  ...u
}, g) {
  return /* @__PURE__ */ i(W, { placement: e, title: t ?? "", children: /* @__PURE__ */ i(
    Re,
    {
      className: `optionIconButton ${c ?? ""}`,
      sx: l,
      "data-testid": "icon-button",
      children: /* @__PURE__ */ i(
        Fe,
        {
          ...u,
          ref: g,
          size: o,
          variant: r,
          color: a,
          active: h,
          disabled: d || s,
          children: s ? /* @__PURE__ */ i(_, { size: 18, color: "inherit" }) : n
        }
      )
    }
  ) });
}
const Le = L(Oe), We = p(Pt, {
  shouldForwardProp: (t) => !["extended", "width", "height"].includes(t)
})(({ theme: t, extended: e, width: n, height: o }) => ({
  ...e && {
    ".MuiMenuItem-root": {
      minHeight: t.spacing(6)
    }
  },
  ...n && {
    ".MuiList-root": {
      width: n,
      minWidth: n
    }
  },
  ...o && {
    ".MuiMenu-paper": {
      overflow: "hidden"
    },
    ".MuiList-root": {
      maxHeight: o
    }
  }
}));
function ho(t) {
  return /* @__PURE__ */ i(We, { ...t });
}
const Ee = p(Gt, {
  shouldForwardProp: (t) => !["extended", "width", "height"].includes(t)
})(({ theme: t, extended: e, width: n, height: o }) => ({
  ...e && {
    ".MuiMenuItem-root": {
      minHeight: t.spacing(6)
    }
  },
  "&.MuiList-root": {
    ...n && {
      width: n,
      minWidth: n
    },
    ...o && {
      maxHeight: o
    }
  }
}));
function bo(t) {
  return /* @__PURE__ */ i(Ee, { ...t });
}
const He = p(vt)(() => ({
  marginTop: "0 !important"
})), _e = p(jt)(
  ({ disabled: t, theme: e }) => ({
    display: "flex",
    alignItems: "center",
    gap: e.spacing(1),
    width: "100%",
    textAlign: "initial",
    ...t && {
      pointerEvents: "none",
      color: e.palette.text.disabled
    }
  })
);
function Dt({
  areAllSelected: t,
  areAnySelected: e,
  selectAll: n,
  selectAllDisabled: o
}) {
  const r = R(), a = $(r);
  return /* @__PURE__ */ i(He, { fixed: !0, children: /* @__PURE__ */ x(
    _e,
    {
      variant: "body2",
      color: "textPrimary",
      component: "button",
      underline: "none",
      disabled: !!o,
      onClick: n,
      tabIndex: 0,
      children: [
        /* @__PURE__ */ i(
          q,
          {
            checked: t,
            indeterminate: e && !t,
            disabled: o
          }
        ),
        a.formatMessage({ id: "c4r.form.selectAll" })
      ]
    }
  ) });
}
function Pe({
  selectedOptions: t,
  options: e,
  onChange: n
}) {
  const [o, r] = T(t ?? []), a = e.length === o.length, l = o.length > 0;
  return H(() => {
    o !== t && r(o);
  }, [t]), {
    areAllSelected: a,
    areAnySelected: l,
    currentOptions: o,
    handleChange: (h) => {
      const {
        target: { value: u }
      } = h, g = typeof u == "string" ? u.split(",") : u.filter((f) => f !== void 0);
      r(g), n(g);
    },
    selectAll: () => {
      const h = e == null ? void 0 : e.filter(({ disabled: u }) => !u).map(({ value: u }) => u);
      h && (h.every(
        (g) => o.includes(g)
      ) ? (r([]), n([])) : (r(h), n(h)));
    },
    unselectAll: () => {
      r([]), n([]);
    }
  };
}
const Ge = p(mt)(({ theme: t }) => ({
  "&.Mui-disabled": {
    pointerEvents: "auto",
    "&:hover": {
      backgroundColor: `${t.palette.background.default} !important`
    }
  }
})), je = p(Y, {
  shouldForwardProp: (t) => t !== "size"
})(({ theme: t, size: e }) => ({
  display: "none",
  position: "absolute",
  top: t.spacing(2),
  right: t.spacing(3.5),
  ".MuiInputBase-root:hover &, .MuiInputBase-root.Mui-focused &": {
    display: "flex"
  },
  ".MuiSvgIcon-root": {
    color: t.palette.text.hint
  },
  ...e === "medium" && {
    top: t.spacing(3),
    right: t.spacing(5)
  }
})), Ve = [], Ne = () => {
};
function Ue({
  options: t = Ve,
  selectedOptions: e,
  size: n = "small",
  placeholder: o,
  showCounter: r,
  showFilters: a = !0,
  onChange: l = Ne,
  selectAllDisabled: c,
  tooltipPlacement: s,
  variant: d,
  ...h
}, u) {
  const {
    areAllSelected: g,
    areAnySelected: f,
    currentOptions: m,
    handleChange: y,
    selectAll: b,
    unselectAll: D
  } = Pe({
    options: t,
    selectedOptions: e,
    onChange: l
  }), w = n === "small", A = w || d === "standard" ? 0 : 2, M = R(), k = $(M), I = `${m.length} ${k.formatMessage({
    id: "c4r.form.selected"
  })}`, F = pt(() => g ? /* @__PURE__ */ i(
    B,
    {
      component: "span",
      variant: w ? "body2" : "body1",
      color: "textPrimary",
      ml: A,
      children: k.formatMessage({ id: "c4r.form.allSelected" })
    }
  ) : f ? /* @__PURE__ */ i(
    B,
    {
      component: "span",
      variant: w ? "body2" : "body1",
      color: "textPrimary",
      ml: A,
      children: r && m.length > 1 ? I : m.join(", ")
    }
  ) : /* @__PURE__ */ i(
    B,
    {
      component: "span",
      variant: w ? "body2" : "body1",
      color: "text.hint",
      ml: A,
      children: o ?? k.formatMessage({ id: "c4r.form.noneSelected" })
    }
  ), [
    g,
    f,
    I,
    m,
    k,
    w,
    A,
    o,
    r
  ]);
  return /* @__PURE__ */ x(
    Te,
    {
      ...h,
      ref: u,
      multiple: !0,
      displayEmpty: !0,
      placeholder: o,
      value: m,
      renderValue: () => F,
      onChange: y,
      size: n,
      variant: d,
      endAdornment: a && f && /* @__PURE__ */ i(je, { position: "end", size: n, children: /* @__PURE__ */ i(O, { onClick: D, size: n, children: /* @__PURE__ */ i(yt, {}) }) }),
      menuProps: {
        PaperProps: {
          sx: {
            ".MuiList-root": {
              paddingTop: 0
            }
          }
        }
      },
      children: [
        a && /* @__PURE__ */ i(
          Dt,
          {
            areAllSelected: g,
            areAnySelected: f,
            selectAll: b,
            selectAllDisabled: c
          }
        ),
        t == null ? void 0 : t.map((C) => {
          const S = /* @__PURE__ */ x(
            Ge,
            {
              value: C.value,
              disabled: C.disabled,
              tabIndex: 0,
              children: [
                /* @__PURE__ */ i(
                  q,
                  {
                    disabled: C.disabled,
                    checked: m.includes(C.value)
                  }
                ),
                /* @__PURE__ */ i(bt, { primary: C.label })
              ]
            },
            C.value
          );
          return C.tooltip ? /* @__PURE__ */ i(
            W,
            {
              title: C.tooltip,
              placement: s,
              children: S
            },
            C.value
          ) : S;
        })
      ]
    }
  );
}
const xo = L(Ue), Ye = p(ft, {
  shouldForwardProp: (t) => t !== "cursor"
})(
  ({ cursor: t, theme: e }) => ({
    "&.MuiTextField-root .MuiInputBase-root": {
      cursor: t,
      paddingRight: e.spacing(1),
      "& input": {
        cursor: t
      },
      "&.Mui-disabled": {
        pointerEvents: "none",
        "& .MuiButtonBase-root": {
          color: e.palette.text.disabled
        }
      },
      "&.MuiInputBase-sizeSmall": {
        paddingRight: e.spacing(0.5)
      }
    },
    "& .MuiFormLabel-root": {
      cursor: t,
      "&.Mui-disabled": {
        pointerEvents: "none"
      }
    }
  })
);
function qe({
  buttonText: t,
  hasFiles: e,
  size: n,
  error: o,
  disabled: r,
  handleReset: a,
  handleOpen: l,
  inProgress: c
}) {
  return /* @__PURE__ */ i(Y, { position: "end", children: c ? /* @__PURE__ */ i(O, { "aria-label": "loading", disabled: !0, size: n, children: /* @__PURE__ */ i(_, { size: 18 }) }) : e ? /* @__PURE__ */ i(
    O,
    {
      onClick: a,
      size: n,
      "aria-label": "delete",
      disabled: r,
      children: /* @__PURE__ */ i(yt, {})
    }
  ) : /* @__PURE__ */ i(
    gt,
    {
      onClick: l,
      size: n,
      variant: "text",
      color: o ? "default" : "primary",
      disabled: r,
      children: t
    }
  ) });
}
function ze({
  name: t,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  multiple: e,
  // multiple prop defined here for compatibility with cloud-native but not used in the component
  handleReset: n,
  handleOpen: o,
  dragOver: r,
  error: a,
  placeholder: l,
  focused: c,
  buttonText: s = "Browse",
  inProgress: d,
  InputProps: h,
  size: u = "small",
  hasFiles: g,
  cursor: f = "pointer",
  ...m
}) {
  return /* @__PURE__ */ i(
    Ye,
    {
      ...m,
      size: u,
      error: a,
      placeholder: l,
      focused: c ?? r,
      cursor: f,
      InputProps: {
        ...h,
        name: t,
        // multiple prop cannot be used here because it is not a valid prop for TextField InputProps
        // not used for any UI logic
        readOnly: !0,
        endAdornment: /* @__PURE__ */ i(
          qe,
          {
            buttonText: s,
            hasFiles: g,
            size: u,
            error: a,
            disabled: !!r,
            handleReset: n,
            handleOpen: o,
            inProgress: d
          }
        )
      }
    }
  );
}
function Ze({
  onChange: t,
  files: e,
  multiple: n,
  placeholder: o,
  uploadInputRef: r
}) {
  const a = R(), l = $(a), [c, s] = T(""), [d, h] = T(!1);
  H(() => {
    !e || e.length === 0 ? s("") : e.length === 1 ? s(e[0].name) : s(
      l.formatMessage(
        { id: "c4r.form.filesSelected" },
        { count: e.length }
      )
    );
  }, [e, l]);
  const u = () => {
    var M;
    (M = r.current) == null || M.click();
  }, g = (M) => {
    M.preventDefault(), h(!0);
  }, f = (M) => {
    M.preventDefault(), h(!1);
  }, m = (M) => {
    M.preventDefault(), h(!1);
    const k = M.dataTransfer.items, I = y(k);
    t == null || t(I);
  }, y = (M) => {
    const k = [];
    for (const I of Array.from(M))
      if (I.kind === "file") {
        const F = I.getAsFile();
        k.push(F);
      }
    return k;
  }, b = (M) => {
    const k = Array.from(M.target.files);
    t == null || t(k);
  }, D = (M) => {
    M.stopPropagation(), s("");
  }, w = pt(() => {
    const M = l.formatMessage(
      { id: "c4r.form.dragPlaceholder" },
      { count: n ? 0 : 1 }
    ), k = l.formatMessage(
      { id: "c4r.form.dragActivePlaceholder" },
      { count: n ? 0 : 1 }
    );
    let I = "";
    return d ? I = k : I = o ?? M, I;
  }, [d, n, o, l]);
  return {
    filesText: c,
    getPlaceholder: w,
    dragOver: d,
    inputEvents: {
      onDragOver: g,
      onDragLeave: f,
      onDrop: m,
      onClick: u
    },
    handleFiles: b,
    handleReset: D
  };
}
const Je = ["application/JSON"];
function yo({
  name: t,
  buttonText: e,
  accept: n,
  files: o,
  inProgress: r,
  onChange: a,
  multiple: l,
  placeholder: c,
  error: s,
  focused: d,
  nativeInputProps: h,
  ...u
}) {
  const g = n ?? Je, f = U(null), {
    filesText: m,
    getPlaceholder: y,
    dragOver: b,
    inputEvents: D,
    handleFiles: w,
    handleReset: A
  } = Ze({
    uploadInputRef: f,
    files: o,
    onChange: a,
    multiple: l,
    placeholder: c
  });
  return /* @__PURE__ */ x(j, { children: [
    /* @__PURE__ */ i(
      ze,
      {
        ...u,
        placeholder: y,
        value: m,
        error: s,
        focused: d ?? b,
        handleReset: A,
        dragOver: b,
        inProgress: r,
        hasFiles: !!m,
        InputProps: D,
        buttonText: e
      }
    ),
    /* @__PURE__ */ i(
      "input",
      {
        ...h,
        ref: f,
        style: { display: "none" },
        type: "file",
        "aria-label": t,
        name: t,
        accept: String(g),
        multiple: l,
        onChange: w
      }
    )
  ] });
}
function Xe({
  disabled: t,
  loading: e,
  ...n
}, o) {
  return /* @__PURE__ */ i(
    z,
    {
      ...n,
      ref: o,
      disabled: t || e,
      popupIcon: e ? /* @__PURE__ */ i(_, { size: 18, color: "inherit" }) : /* @__PURE__ */ i(J, {}),
      "data-name": "autocomplete",
      ListboxProps: {
        "aria-multiselectable": !1,
        ...n.ListboxProps
      }
    }
  );
}
const Mo = L(Xe), At = (t) => t && typeof t == "object" ? t.title ?? String(t) : String(t), kt = (t, e) => typeof t != "object" || t === null ? { value: t, multiple: e } : { ...t, multiple: e }, It = (t) => /* @__PURE__ */ i("span", { "data-testid": "more-options-tag", children: `+${t}` });
function wt() {
  return { renderOption: (e, n, o, r, a) => {
    const {
      title: l,
      inputValue: c,
      divider: s,
      fixed: d,
      extended: h,
      dense: u,
      destructive: g,
      disabled: f,
      subtitle: m,
      iconColor: y,
      startAdornment: b,
      endAdornment: D,
      alternativeTitle: w,
      secondaryText: A,
      multiple: M
    } = n, { key: k, ...I } = e, F = typeof n == "string" || typeof n == "number", C = (S, E, tt, et) => tt || et || (E && typeof E == "object" && "value" in E ? String(E.value) : S(E));
    return /* @__PURE__ */ i(Ot, { children: s ? /* @__PURE__ */ i(G, {}) : /* @__PURE__ */ x(j, { children: [
      c && /* @__PURE__ */ i(G, {}),
      /* @__PURE__ */ x(
        vt,
        {
          ...I,
          ...!F && {
            fixed: d,
            extended: h,
            dense: u,
            destructive: g,
            disabled: f,
            subtitle: m,
            iconColor: y
          },
          "aria-disabled": m || f,
          "aria-selected": o.selected,
          children: [
            !m && (b || M || a) && /* @__PURE__ */ x(Vt, { children: [
              a || M && /* @__PURE__ */ i(q, { checked: o.selected }),
              b
            ] }),
            /* @__PURE__ */ x(bt, { children: [
              C(
                r ?? At,
                n,
                w,
                l
              ),
              A && /* @__PURE__ */ i(
                B,
                {
                  component: "p",
                  variant: "caption",
                  color: "text.secondary",
                  children: A
                }
              )
            ] }),
            !m && D
          ]
        }
      )
    ] }) }, k);
  } };
}
function Ke({
  getOptionLabel: t,
  newItemLabel: e,
  newItemIcon: n,
  multiple: o
}) {
  const r = R(), a = $(r), l = Nt(), { renderOption: c } = wt();
  return {
    creatableFilterOptions: (u, g) => {
      const f = l(
        u,
        g
      ), { inputValue: m } = g, y = u.some(
        (b) => m === t(b)
      );
      if (m.length > 1 && m !== "" && !y) {
        let b;
        typeof e == "function" ? b = e(m) : e ? b = `${e} "${m}"` : b = `${a.formatMessage({ id: "c4r.form.add" })} "${m}"`, f.push({
          inputValue: m,
          title: b
        });
      }
      return f;
    },
    creatableOptionLabel: (u) => typeof u == "string" ? u : u.inputValue ? u.inputValue : t(u),
    creatableRenderOption: (u, g, f) => {
      const m = g.inputValue ? n ?? /* @__PURE__ */ i(de, {}) : void 0, y = kt(g, !!o);
      return c(
        u,
        y,
        f,
        t,
        m
      );
    }
  };
}
function Bt({
  options: t,
  value: e,
  onChange: n,
  getOptionLabel: o
}) {
  const [r, a] = T(
    Array.isArray(e) ? e : e ? [e] : []
  ), { renderOption: l } = wt();
  H(() => {
    const g = Array.isArray(e) ? e : e ? [e] : [];
    a(g);
  }, [e]);
  const c = r.length === t.length, s = r.length > 0 && r.length < t.length;
  return {
    multipleValue: r,
    allSelected: c,
    someSelected: s,
    handleSelectAll: (g) => {
      const f = c ? [] : [...t];
      a(f), n == null || n(
        g,
        f,
        "selectOption"
      );
    },
    handleChange: (g, f, m) => {
      a(f === null ? [] : f), n == null || n(g, f, m);
    },
    multipleRenderOption: (g, f, m) => {
      const y = kt(f, !0);
      return l(
        g,
        y,
        m,
        o
      );
    }
  };
}
function Qe({
  children: t,
  showFilters: e,
  allSelected: n,
  someSelected: o,
  handleSelectAll: r = () => {
  },
  multiple: a,
  ...l
}, c) {
  return /* @__PURE__ */ x(
    "ul",
    {
      ref: c,
      ...l,
      role: "listbox",
      "aria-multiselectable": a,
      children: [
        e && a && /* @__PURE__ */ i(
          Dt,
          {
            areAllSelected: !!n,
            areAnySelected: !!o,
            selectAll: r
          }
        ),
        t
      ]
    }
  );
}
const St = L(Qe);
function tn({
  newItemLabel: t,
  newItemIcon: e,
  getOptionLabel: n = At,
  multiple: o,
  disableCloseOnSelect: r,
  disabled: a,
  loading: l,
  showFilters: c,
  options: s = [],
  value: d,
  onChange: h,
  getLimitTagsText: u,
  ...g
}, f) {
  const { freeSolo: m = !0, ...y } = g, {
    multipleValue: b,
    allSelected: D,
    someSelected: w,
    handleSelectAll: A,
    handleChange: M
  } = Bt({
    options: s,
    value: d,
    onChange: h
  }), {
    creatableFilterOptions: k,
    creatableOptionLabel: I,
    creatableRenderOption: F
  } = Ke({
    getOptionLabel: n,
    newItemLabel: t,
    newItemIcon: e,
    multiple: o
  });
  return /* @__PURE__ */ i(
    z,
    {
      ...y,
      ref: f,
      options: s,
      value: o ? b : d,
      onChange: M,
      filterOptions: k,
      getOptionLabel: I,
      renderOption: F,
      freeSolo: m,
      forcePopupIcon: !0,
      multiple: o,
      disableCloseOnSelect: r ?? o,
      ListboxComponent: St,
      ListboxProps: {
        showFilters: c,
        allSelected: D,
        someSelected: w,
        handleSelectAll: A,
        multiple: o
      },
      getLimitTagsText: u ?? It,
      disabled: a || l,
      popupIcon: l ? /* @__PURE__ */ i(_, { size: 18, color: "inherit" }) : /* @__PURE__ */ i(J, {}),
      "data-name": "creatable-autocomplete"
    }
  );
}
const Co = L(tn);
function en({
  renderOption: t,
  disableCloseOnSelect: e = !0,
  disabled: n,
  loading: o,
  showFilters: r,
  options: a,
  value: l,
  onChange: c,
  getOptionLabel: s,
  getLimitTagsText: d,
  ...h
}, u) {
  const {
    multipleValue: g,
    allSelected: f,
    someSelected: m,
    handleSelectAll: y,
    handleChange: b,
    multipleRenderOption: D
  } = Bt({
    options: a,
    value: l,
    onChange: c,
    getOptionLabel: s
  });
  return /* @__PURE__ */ i(
    z,
    {
      ...h,
      ref: u,
      options: a,
      value: g,
      onChange: b,
      getOptionLabel: s,
      renderOption: t ?? D,
      ListboxComponent: St,
      ListboxProps: {
        showFilters: r,
        allSelected: f,
        someSelected: m,
        handleSelectAll: y,
        multiple: !0
      },
      multiple: !0,
      getLimitTagsText: d ?? It,
      disableCloseOnSelect: e,
      disabled: n || o,
      popupIcon: o ? /* @__PURE__ */ i(_, { size: 18, color: "inherit" }) : /* @__PURE__ */ i(J, {}),
      "data-name": "multiple-autocomplete"
    }
  );
}
const vo = L(en), nn = p("div", {
  shouldForwardProp: (t) => t !== "variant"
})(({ variant: t, theme: e }) => ({
  width: "100%",
  borderRadius: e.spacing(0.5),
  ...t === "outlined" && {
    backgroundColor: e.palette.background.paper,
    boxShadow: `inset 0 0 0 1px ${e.palette.divider}`
  }
}));
function Do({
  variant: t = "standard",
  items: e,
  ...n
}) {
  return /* @__PURE__ */ i(nn, { ...n, variant: t, children: e.map((o, r) => /* @__PURE__ */ x(
    Ut,
    {
      disabled: o.disabled,
      defaultExpanded: o.defaultExpanded,
      onChange: o.onChange,
      children: [
        /* @__PURE__ */ i(
          Yt,
          {
            "aria-controls": `${r}-content`,
            id: `${r}-header`,
            children: o.summary
          }
        ),
        /* @__PURE__ */ i(qt, { children: o.content })
      ]
    },
    r
  )) });
}
const it = {
  large: 5,
  medium: 4,
  small: 3,
  xsmall: 2.25
}, on = p(zt, {
  shouldForwardProp: (t) => t !== "size" && t !== "disabled"
})(({ theme: t, size: e = "medium", disabled: n = !1 }) => ({
  width: t.spacing(it[e]),
  height: t.spacing(it[e]),
  ...t.typography.subtitle1,
  ...e === "large" && {
    ...t.typography.h6
  },
  ...e === "small" && {
    ...t.typography.caption,
    fontWeight: 500
  },
  ...e === "xsmall" && {
    ...t.typography.caption,
    fontWeight: 500,
    svg: {
      width: P,
      height: P
    }
  },
  ...n && {
    opacity: 0.6
  }
}));
function Ao(t) {
  return /* @__PURE__ */ i(on, { ...t });
}
const Tt = 480, rn = p(Zt)(({ theme: t }) => ({
  bottom: t.spacing(2),
  right: t.spacing(2),
  left: t.spacing(2),
  [t.breakpoints.up("sm")]: {
    bottom: t.spacing(4),
    right: "auto",
    left: "50%",
    width: "100%",
    maxWidth: `${Tt}px`
  }
})), an = p(v, {
  shouldForwardProp: (t) => t !== "autoWidth"
})(({ autoWidth: t, theme: e }) => ({
  minWidth: "100%",
  maxWidth: `${Tt}px`,
  margin: e.spacing(0, 1),
  ...t && {
    minWidth: "auto"
  },
  [e.breakpoints.up("sm")]: {
    minWidth: e.spacing(40),
    ...t && {
      minWidth: "auto"
    }
  }
})), ln = p(Ct, {
  shouldForwardProp: (t) => !["hasActions", "closeable"].includes(t)
})(({ hasActions: t, closeable: e, icon: n, theme: o }) => ({
  position: "relative",
  display: "flex",
  flexWrap: "wrap",
  columnGap: o.spacing(1),
  rowGap: o.spacing(0.25),
  padding: o.spacing(1),
  paddingLeft: o.spacing(2),
  color: o.palette.common.white,
  backgroundColor: o.palette.common.black,
  ".MuiAlert-message": {
    padding: o.spacing(0.75, 0)
  },
  ".MuiAlert-message .MuiTypography-root, .MuiAlert-icon": {
    color: o.palette.common.white
  },
  ".MuiAlert-message .MuiTypography-root:not(.MuiAlertTitle-root)": {
    ...o.typography.body2
  },
  ".MuiAlert-message .MuiCircularProgress-circle": {
    color: o.palette.common.white
  },
  ".MuiAlert-icon": {
    position: "absolute",
    top: o.spacing(1),
    left: o.spacing(1.5),
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: o.spacing(3),
    marginTop: o.spacing(0.5)
  },
  "&.MuiAlert-standardError": {
    backgroundColor: o.palette.error.main
  },
  ...n !== !1 && {
    paddingLeft: o.spacing(5.5)
  },
  ...e && {
    paddingRight: o.spacing(6)
  },
  ...!e && !t && {
    paddingRight: o.spacing(1.5)
  },
  ...t && {
    ".MuiAlert-message": {
      minWidth: "fit-content",
      padding: o.spacing(0.75, 0)
    }
  }
})), cn = p(v)(({ theme: t }) => ({
  position: "absolute",
  top: t.spacing(1),
  right: t.spacing(1),
  "& button:hover, & button:focus-visible": {
    backgroundColor: t.palette.white[8]
  },
  svg: {
    color: t.palette.white[60]
  }
}));
function ko({
  severity: t = "neutral",
  autoHideDuration: e = ot,
  closeable: n = !0,
  children: o,
  title: r,
  action: a,
  open: l,
  onClose: c = () => {
  },
  autoWidth: s,
  icon: d,
  ...h
}) {
  const u = R(), g = $(u);
  return /* @__PURE__ */ i(Jt, { children: /* @__PURE__ */ i(
    rn,
    {
      ...h,
      open: l,
      autoHideDuration: e === null ? null : e || ot,
      onClose: c,
      TransitionComponent: s ? Xt : xt,
      "data-auto-width": s,
      children: /* @__PURE__ */ x(
        an,
        {
          sx: {
            position: "relative"
          },
          autoWidth: s,
          children: [
            /* @__PURE__ */ i(
              ln,
              {
                severity: t,
                action: a,
                icon: d === !1 || t === "neutral" && !d ? !1 : d,
                elevation: 6,
                hasActions: !!a,
                closeable: n,
                title: r,
                children: o
              }
            ),
            n && /* @__PURE__ */ i(cn, { children: /* @__PURE__ */ i(
              Le,
              {
                color: "default",
                onClick: (D) => c(D, "timeout"),
                icon: /* @__PURE__ */ i(Mt, {}),
                tooltip: g.formatMessage({
                  id: "c4r.button.close"
                })
              }
            ) })
          ]
        }
      )
    }
  ) });
}
const sn = p("div")(({ theme: t }) => ({
  display: "flex",
  alignItems: "center",
  height: le,
  marginRight: t.spacing(1.5)
})), dn = p(O)(({ theme: t }) => ({
  marginRight: t.spacing(1),
  "&.MuiButtonBase-root svg path": {
    fill: t.palette.brand.appBarContrastText
  }
})), un = p(G)(({ theme: t }) => ({
  borderColor: Kt(t.palette.brand.appBarContrastText, 0.12)
}));
function pn({
  onClickMenu: t
}) {
  return (
    // replacing deprecated `<Hidden />` with sx following this MUI5 guide:
    // https://mui.com/material-ui/migration/v5-component-changes/#hidden
    /* @__PURE__ */ i(
      v,
      {
        sx: {
          display: { md: "none", xs: "block" }
        },
        children: /* @__PURE__ */ x(sn, { children: [
          /* @__PURE__ */ i(dn, { onClick: t, children: /* @__PURE__ */ i(ue, {}) }),
          /* @__PURE__ */ i(un, { orientation: "vertical", flexItem: !0 })
        ] })
      }
    )
  );
}
const gn = p("div")(({ theme: t }) => ({
  display: "flex",
  marginRight: t.spacing(1.5),
  "& a": {
    display: "flex"
  },
  "& svg, & img": {
    width: t.spacing(4),
    height: t.spacing(4)
  }
}));
function fn({ logo: t }) {
  return /* @__PURE__ */ i(gn, { children: t });
}
const mn = p(B)({
  display: "flex",
  alignItems: "center",
  whiteSpace: "nowrap"
});
function hn({ text: t }) {
  const e = V();
  return /* @__PURE__ */ i(
    mn,
    {
      component: "span",
      variant: "subtitle1",
      color: e.palette.brand.appBarContrastText,
      children: t
    }
  );
}
const bn = p(B)(({ theme: t }) => ({
  display: "flex",
  alignItems: "center",
  "&::before": {
    content: '"/"',
    margin: t.spacing(0, 1),
    opacity: 0.6,
    color: t.palette.brand.appBarContrastText
  }
}));
function xn({ text: t }) {
  const e = V();
  return /* @__PURE__ */ i(
    bn,
    {
      component: "span",
      variant: "body2",
      weight: "strong",
      color: e.palette.brand.appBarContrastText,
      children: t
    }
  );
}
const yn = p(te)(({ theme: t }) => ({
  backgroundColor: t.palette.brand.appBarMain,
  "& .MuiTypography-root": {
    color: t.palette.brand.appBarContrastText
  },
  "& .MuiIconButton-root path": {
    fill: t.palette.brand.appBarContrastText
  }
})), Mn = p("div")(({ theme: t }) => ({
  display: "flex",
  alignItems: "center",
  maxWidth: "calc(100% - 300px)",
  overflow: "hidden",
  [t.breakpoints.down("sm")]: {
    minWidth: "192px"
  }
})), Cn = p("div")(({ theme: t }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  flex: 1,
  marginLeft: t.spacing(1)
}));
function Io({
  children: t,
  brandLogo: e,
  brandText: n,
  secondaryText: o,
  showBurgerMenu: r = !1,
  onClickMenu: a,
  ...l
}) {
  return /* @__PURE__ */ i(yn, { ...l, children: /* @__PURE__ */ x(Qt, { children: [
    /* @__PURE__ */ x(Mn, { children: [
      r && /* @__PURE__ */ i(pn, { onClickMenu: a }),
      e && /* @__PURE__ */ i(fn, { logo: e }),
      n && /* @__PURE__ */ i(hn, { text: n }),
      o && /* @__PURE__ */ i(xn, { text: o })
    ] }),
    /* @__PURE__ */ i(Cn, { children: t })
  ] }) });
}
const vn = p(v, {
  shouldForwardProp: (t) => !["size", "variant"].includes(t)
})(({ size: t, variant: e, theme: n }) => ({
  position: "absolute",
  right: n.spacing(5.75),
  ...t === "small" && {
    right: n.spacing(4),
    top: "3px"
    // to align with design specs
  },
  ...e === "standard" && {
    right: n.spacing(4.75),
    ...t === "small" && {
      right: n.spacing(3.5)
    }
  }
}));
function K({
  size: t,
  variant: e,
  ...n
}) {
  const o = R(), r = $(o);
  return /* @__PURE__ */ i(vn, { size: t, variant: e, children: /* @__PURE__ */ i(
    O,
    {
      ...n,
      size: t,
      "aria-label": r.formatMessage({
        id: "c4r.form.clearSelection"
      })
    }
  ) });
}
const Dn = p(v, {
  shouldForwardProp: (t) => !["size", "variant", "readOnly"].includes(t)
})(({ size: t, variant: e, readOnly: n, theme: o }) => ({
  // There is no specific slot to change TextField styles at DatePicker level, so we need to wrap our component to isolate this override. https://mui.com/x/react-date-pickers/date-picker/#customization
  ".MuiInputBase-root": {
    "& .clearButton svg": {
      color: o.palette.text.hint
    },
    ...t === "small" && {
      paddingRight: `${o.spacing(1)} !important`
    },
    ...t === "medium" && {
      "& .MuiInputAdornment-root": {
        "& .MuiIconButton-edgeEnd": {
          marginRight: o.spacing(-1)
        }
      }
    },
    ...e === "standard" && {
      paddingRight: `${o.spacing(1)} !important`,
      ...t === "small" && {
        paddingRight: `${o.spacing(0.5)} !important`
      }
    },
    ...n && {
      "& .MuiInputAdornment-root": {
        "& svg": {
          color: o.palette.text.disabled
        }
      }
    }
  }
}));
function Q({
  children: t,
  size: e,
  variant: n,
  readOnly: o,
  ...r
}) {
  return /* @__PURE__ */ i(Dn, { ...r, size: e, variant: n, readOnly: o, children: t });
}
function rt({
  handleClear: t,
  variant: e = "outlined",
  size: n = "small",
  label: o,
  labelHelpTooltip: r,
  type: a,
  helperText: l,
  placeholder: c,
  slotProps: s,
  slots: d,
  error: h,
  showCalendar: u = !0,
  readOnly: g,
  ...f
}) {
  const m = R(), y = $(m);
  return (
    // Don't remove className, it's used for styling
    /* @__PURE__ */ i(v, { className: "CartoDatePicker-root", "data-testid": "date-picker", children: /* @__PURE__ */ i(Q, { size: n, variant: e, readOnly: g, children: /* @__PURE__ */ i(
      fe,
      {
        ...f,
        label: o && /* @__PURE__ */ i(
          X,
          {
            label: o,
            type: a,
            icon: r && /* @__PURE__ */ i(W, { title: r, children: /* @__PURE__ */ i(Z, { htmlColor: "text.secondary" }) })
          }
        ),
        slotProps: {
          // https://mui.com/x/api/date-pickers/date-picker/#slots
          textField: {
            variant: e,
            helperText: l,
            placeholder: c,
            size: n,
            error: h ?? void 0,
            // undefined is needed to allow the component to control the error state for the default validation
            inputProps: {
              "data-testid": "date-picker-input"
            }
          },
          field: {
            clearable: !!t,
            onClear: t
          },
          ...s
        },
        slots: {
          clearButton: (b) => /* @__PURE__ */ i(K, { ...b, size: n, variant: e }),
          openPickerButton: (b) => /* @__PURE__ */ i(
            O,
            {
              ...b,
              size: n,
              "aria-label": y.formatMessage({
                id: "c4r.form.chooseDate"
              })
            }
          ),
          ...d
        },
        disableOpenPicker: !u,
        readOnly: g
      }
    ) }) })
  );
}
const An = p(v, {
  shouldForwardProp: (t) => ![
    "isSelected",
    "isStartDate",
    "isEndDate",
    "isSelectedMonth",
    "isLastDay",
    "isFirstDay"
  ].includes(t)
})(
  ({
    theme: t,
    isSelected: e,
    isStartDate: n,
    isEndDate: o,
    isSelectedMonth: r,
    isLastDay: a,
    isFirstDay: l
  }) => ({
    position: "relative",
    margin: t.spacing(0.25),
    "& .MuiPickersDay-root": {
      margin: 0
    },
    // Highlight the selected date range
    ...e && r && {
      // Creates a continuous background color between start and end date
      "&::before": {
        content: '""',
        position: "absolute",
        top: 0,
        right: "-2px",
        bottom: 0,
        left: "-2px",
        backgroundColor: t.palette.primary.background,
        // Selected start date OR first day of the month
        ...(n || l) && {
          left: 0,
          borderRadius: `${t.shape.borderRadius}px 0 0 ${t.shape.borderRadius}px`
        },
        // Selected end date OR last day of the month
        ...(o || a) && {
          right: 0,
          borderRadius: `0 ${t.shape.borderRadius}px ${t.shape.borderRadius}px 0`
        }
      },
      // First selected day
      "&:first-of-type::before": {
        left: 0,
        borderRadius: `${t.shape.borderRadius}px 0 0 ${t.shape.borderRadius}px`
      },
      // Last selected day
      "&:last-of-type::before": {
        right: 0,
        borderRadius: `0 ${t.shape.borderRadius}px ${t.shape.borderRadius}px 0`
      },
      // First day of month and last selected day in a week
      ...l && {
        "&:last-of-type::before": {
          left: 0,
          right: 0,
          borderRadius: t.shape.borderRadius
        }
      },
      // Last day of month and first selected day in a week
      ...a && {
        "&:first-of-type::before": {
          left: 0,
          right: 0,
          borderRadius: t.shape.borderRadius
        }
      },
      "& .MuiPickersDay-today": {
        borderColor: `${t.palette.default.outlinedBorder} !important`,
        ...(n || o) && {
          boxShadow: `0 0 0 1px inset ${t.palette.background.paper}`
        }
      },
      // Always having a solid background color below to avoid color blending
      "&::after": {
        content: '""',
        position: "absolute",
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        backgroundColor: t.palette.background.paper,
        borderRadius: t.shape.borderRadius,
        transition: "background-color 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms"
      },
      "&:hover::after": {
        backgroundColor: t.palette.primary.relatedLight
      }
    }
  })
), kn = p(me, {
  shouldForwardProp: (t) => t !== "isDateRangeLimit"
})(({ theme: t, isDateRangeLimit: e }) => ({
  "&.MuiPickersDay-root": {
    position: "relative",
    zIndex: 1,
    "&.Mui-selected": {
      color: t.palette.text.primary
    },
    // Is selected date within the range
    ...e && {
      "&.Mui-selected": {
        backgroundColor: `${t.palette.primary.main} !important`,
        color: t.palette.primary.contrastText,
        "&:hover": {
          backgroundColor: `${t.palette.primary.dark} !important`
        }
      }
    }
  }
})), at = (t, e) => !t || !e ? !1 : t.getFullYear() === e.getFullYear() && t.getMonth() === e.getMonth() && t.getDate() === e.getDate();
function lt({
  day: t,
  startDate: e,
  endDate: n,
  selectedMonth: o,
  ...r
}) {
  const a = !!(e && at(e, t)), l = !!(n && at(n, t)), c = !!(e && n && t.getTime() >= e.getTime() && t.getTime() <= n.getTime()), s = t.getDate() === 1, d = t.getDate() === new Date(t.getFullYear(), t.getMonth() + 1, 0).getDate(), h = !!(o && t.getMonth() === o.getMonth());
  return /* @__PURE__ */ i(
    An,
    {
      isSelected: c,
      isStartDate: a,
      isEndDate: l,
      isSelectedMonth: h,
      isLastDay: d,
      isFirstDay: s,
      children: /* @__PURE__ */ i(
        kn,
        {
          ...r,
          day: t,
          selected: c || a || l,
          isDateRangeLimit: a || l
        }
      )
    }
  );
}
const In = p(v, {
  shouldForwardProp: (t) => !["variant"].includes(t)
})(({ variant: t, theme: e }) => ({
  display: "flex",
  gap: t === "standard" ? e.spacing(1) : "1px",
  "& .CartoDatePicker-root": {
    // Start date field
    "&:first-of-type": {
      ".MuiInputBase-root": {
        borderRadius: e.spacing(0.5, 0, 0, 0.5),
        boxShadow: `1px 0 0 0 ${e.palette.default.outlinedBorder}`,
        ...t === "outlined" && {
          // Remove border from the right side only in its default state. Nested negation selector to target only specific Mui rules, otherwise it would force us to rewrite the state styles.
          "&:not(:hover):not(.Mui-focused):not(.Mui-error) .MuiOutlinedInput-notchedOutline": {
            borderRightColor: "transparent"
          }
        },
        ...t === "filled" && {
          "&::before, &::after": {
            borderRadius: e.spacing(0.5, 0, 0, 0.5)
          }
        },
        ...t === "standard" && {
          boxShadow: "none",
          borderRadius: 0
        }
      }
    },
    // End date field
    "&:last-of-type": {
      ".MuiInputBase-root": {
        borderRadius: e.spacing(0, 0.5, 0.5, 0),
        ...t === "outlined" && {
          // Remove border from the left side only in its default state
          "&:not(:hover):not(.Mui-focused):not(.Mui-error) .MuiOutlinedInput-notchedOutline": {
            borderLeftColor: "transparent"
          }
        },
        ...t === "filled" && {
          "&::before, &::after": {
            borderRadius: e.spacing(0, 0.5, 0.5, 0)
          }
        },
        ...t === "standard" && {
          borderRadius: 0
        }
      }
    }
  }
}));
function wo({
  globalHelperText: t,
  error: e,
  variant: n = "outlined",
  startProps: o,
  endProps: r,
  ...a
}) {
  const l = R(), c = $(l), [s, d] = T(!1), [h, u] = T(!1), [g, f] = T(
    (o == null ? void 0 : o.value) || null
  ), [m, y] = T((r == null ? void 0 : r.value) || null), [b, D] = T(
    (r == null ? void 0 : r.value) ?? (o == null ? void 0 : o.value) ?? /* @__PURE__ */ new Date()
  ), w = e ?? (o == null ? void 0 : o.error) ?? (r == null ? void 0 : r.error), A = (C, S) => {
    f(C), o != null && o.onChange && o.onChange(C, S), C && S.validationError === null && !h && S.trigger === null && (u(!1), d(!0));
  }, M = (C, S) => {
    y(C), r != null && r.onChange && r.onChange(C, S);
  }, k = () => {
    u(!0), d(!1), setTimeout(() => {
      D(g ?? /* @__PURE__ */ new Date());
    }, 120);
  }, I = () => {
    u(!1), d(!0), setTimeout(() => {
      D(m ?? g ?? /* @__PURE__ */ new Date());
    }, 120);
  }, F = () => {
    u(!1), d(!0), setTimeout(() => {
      D(m ?? g ?? /* @__PURE__ */ new Date());
    }, 120);
  };
  return /* @__PURE__ */ x(v, { children: [
    /* @__PURE__ */ x(In, { variant: n, children: [
      /* @__PURE__ */ i(
        rt,
        {
          ...a,
          ...o,
          value: (o == null ? void 0 : o.value) ?? g,
          maxDate: m ?? void 0,
          label: (o == null ? void 0 : o.label) ?? c.formatMessage({ id: "c4r.form.startDate" }),
          slotProps: {
            popper: {
              placement: "bottom-start",
              "aria-label": c.formatMessage({
                id: "c4r.form.startDateCalendar"
              })
            },
            ...o == null ? void 0 : o.slotProps
          },
          slots: {
            openPickerIcon: pe,
            day: (C) => /* @__PURE__ */ i(
              lt,
              {
                ...C,
                startDate: g,
                endDate: m,
                selectedMonth: b
              }
            ),
            ...o == null ? void 0 : o.slots
          },
          error: (o == null ? void 0 : o.error) ?? e,
          open: h,
          onChange: A,
          onOpen: k,
          onClose: I,
          onMonthChange: (C) => D(C),
          variant: n
        }
      ),
      /* @__PURE__ */ i(
        rt,
        {
          ...a,
          ...r,
          value: (r == null ? void 0 : r.value) ?? m,
          minDate: g ?? void 0,
          slotProps: {
            popper: {
              "aria-label": c.formatMessage({
                id: "c4r.form.endDateCalendar"
              })
            },
            ...r == null ? void 0 : r.slotProps
          },
          slots: {
            day: (C) => /* @__PURE__ */ i(
              lt,
              {
                ...C,
                startDate: g,
                endDate: m,
                selectedMonth: b
              }
            ),
            ...r == null ? void 0 : r.slots
          },
          label: (r == null ? void 0 : r.label) ?? c.formatMessage({ id: "c4r.form.endDate" }),
          error: (r == null ? void 0 : r.error) ?? e,
          open: s,
          onOpen: F,
          onClose: () => d(!1),
          onChange: M,
          onMonthChange: (C) => D(C),
          variant: n
        }
      )
    ] }),
    t && /* @__PURE__ */ i(ht, { error: w, children: t })
  ] });
}
const $t = (t, e, n, o) => {
  const r = t == null ? void 0 : t.includes("hours"), a = t == null ? void 0 : t.includes("seconds"), l = t == null ? void 0 : t.includes("minutes"), c = (t == null ? void 0 : t.length) === 1 && t[0] === "hours";
  if (o) return o;
  const s = [];
  return e && s.push("MM/dd/yyyy "), r && s.push(n ? "hh" : "HH"), c || s.push(":"), l && s.push("mm"), a && s.push(":ss"), n && s.push(" a"), s.join("");
};
function Bo({
  handleClear: t,
  variant: e = "outlined",
  size: n = "small",
  label: o,
  labelHelpTooltip: r,
  type: a,
  helperText: l,
  placeholder: c,
  error: s,
  showClock: d = !0,
  readOnly: h,
  slotProps: u,
  slots: g,
  ampm: f = !0,
  views: m = ["hours", "minutes"],
  format: y,
  ...b
}) {
  const D = R(), w = $(D), A = U(null), [M, k] = T(0);
  return H(() => {
    if (!A.current) return;
    const I = new ResizeObserver((F) => {
      var S;
      const C = (S = F[0]) == null ? void 0 : S.contentRect.width;
      C && k(C);
    });
    return I.observe(A.current), () => {
      I.disconnect();
    };
  }, []), /* @__PURE__ */ i(
    Q,
    {
      size: n,
      variant: e,
      readOnly: h,
      "data-testid": "time-picker",
      children: /* @__PURE__ */ i(
        he,
        {
          ...b,
          ref: A,
          label: /* @__PURE__ */ i(
            X,
            {
              label: o ?? w.formatMessage({ id: "c4r.form.time" }),
              type: a,
              icon: r && /* @__PURE__ */ i(W, { title: r, children: /* @__PURE__ */ i(Z, { htmlColor: "text.secondary" }) })
            }
          ),
          views: ["hours"],
          format: $t(m, !1, f, y),
          slotProps: {
            textField: {
              variant: e,
              helperText: l,
              placeholder: c,
              size: n,
              error: s ?? void 0,
              // undefined is needed to allow the component to control the error state for the default validation
              inputProps: {
                "data-testid": "time-picker-input"
              }
            },
            field: {
              clearable: !!t,
              onClear: t
            },
            popper: {
              placement: "bottom-end"
            },
            layout: {
              sx: {
                width: M
              }
            },
            ...u
          },
          slots: {
            clearButton: (I) => /* @__PURE__ */ i(K, { ...I, size: n, variant: e }),
            openPickerButton: (I) => /* @__PURE__ */ i(
              O,
              {
                ...I,
                size: n,
                "aria-label": w.formatMessage({
                  id: "c4r.form.chooseDate"
                })
              }
            ),
            ...g
          },
          disableOpenPicker: !d,
          readOnly: h,
          ampm: f
        }
      )
    }
  );
}
function So({
  handleClear: t,
  variant: e = "outlined",
  size: n = "small",
  label: o,
  labelHelpTooltip: r,
  type: a,
  helperText: l,
  placeholder: c,
  error: s,
  showCalendar: d = !0,
  readOnly: h,
  slotProps: u,
  slots: g,
  ampm: f = !0,
  views: m = ["hours", "minutes"],
  format: y,
  ...b
}) {
  const D = R(), w = $(D);
  return /* @__PURE__ */ i(
    Q,
    {
      size: n,
      variant: e,
      readOnly: h,
      "data-testid": "date-time-picker",
      children: /* @__PURE__ */ i(
        be,
        {
          ...b,
          label: /* @__PURE__ */ i(
            X,
            {
              label: o ?? w.formatMessage({ id: "c4r.form.time" }),
              type: a,
              icon: r && /* @__PURE__ */ i(W, { title: r, children: /* @__PURE__ */ i(Z, { htmlColor: "text.secondary" }) })
            }
          ),
          views: ["year", "month", "day", "hours"],
          format: $t(m, !0, f, y),
          slotProps: {
            textField: {
              variant: e,
              helperText: l,
              placeholder: c,
              size: n,
              error: s ?? void 0,
              // undefined is needed to allow the component to control the error state for the default validation
              inputProps: {
                "data-testid": "date-time-picker-input"
              }
            },
            field: {
              clearable: !!t,
              onClear: t
            },
            ...u
          },
          slots: {
            clearButton: (A) => /* @__PURE__ */ i(K, { ...A, size: n, variant: e }),
            openPickerButton: (A) => /* @__PURE__ */ i(
              O,
              {
                ...A,
                size: n,
                "aria-label": w.formatMessage({
                  id: "c4r.form.chooseDate"
                })
              }
            ),
            ...g
          },
          disableOpenPicker: !d,
          readOnly: h,
          ampm: f
        }
      )
    }
  );
}
const wn = [{ outlinedBullet: !1, value: "" }], Bn = p("ul")(({ theme: t }) => ({
  listStyle: "none",
  paddingLeft: 0,
  margin: t.spacing(0.5, 0, 0, 0)
})), Sn = p("li")(({ theme: t }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  "&:not(:last-child)": {
    marginBottom: t.spacing(0.5)
  }
})), Tn = p("span")(({ theme: t }) => ({
  width: t.spacing(1),
  height: t.spacing(1),
  marginRight: t.spacing(0.5),
  border: `2px solid ${t.palette.qualitative.bold[1]}`,
  borderRadius: "50%",
  backgroundColor: t.palette.qualitative.bold[1]
})), $n = p(B)(({ theme: t }) => ({
  minWidth: t.spacing(10),
  marginRight: t.spacing(1.5)
}));
function To({
  items: t = wn,
  title: e
}) {
  return /* @__PURE__ */ x(j, { children: [
    e && /* @__PURE__ */ i(B, { color: "inherit", variant: "caption", weight: "medium", children: e }),
    /* @__PURE__ */ i(Bn, { children: t.map((n, o) => /* @__PURE__ */ x(Sn, { children: [
      /* @__PURE__ */ i(
        Tn,
        {
          style: {
            backgroundColor: `${n.outlinedBullet ? "transparent" : n.color}`,
            borderColor: n.color
          }
        }
      ),
      n.category && /* @__PURE__ */ i($n, { color: "inherit", variant: "caption", children: n.category }),
      /* @__PURE__ */ i(B, { color: "inherit", variant: "caption", weight: "medium", children: n.value })
    ] }, o)) })
  ] });
}
const ct = {
  small: "480px",
  medium: "640px",
  large: "640px",
  xlarge: "720px"
}, st = {
  small: {
    width: "432px",
    maxWidth: "432px"
  },
  medium: {
    width: "592px",
    maxWidth: "592px"
  },
  large: {
    width: "768px",
    maxWidth: "768px",
    minHeight: "576px"
  },
  xlarge: {
    width: "calc(100vw - 80px)",
    height: "calc(100vh - 80px)",
    maxWidth: "960px"
  }
}, dt = p(ee, {
  shouldForwardProp: (t) => !["fullScreen", "height", "width", "hasForm"].includes(t)
})(
  ({
    fullScreen: t,
    height: e,
    width: n,
    hasForm: o,
    size: r = "small",
    theme: a
  }) => ({
    "&.MuiPaper-root": {
      position: "relative",
      display: "flex",
      flexDirection: "column",
      margin: a.spacing(5),
      borderRadius: a.spacing(1),
      ...st[r],
      maxHeight: ct[r],
      [`@media (max-height:${ct[r]})`]: {
        maxHeight: "calc(100vh - 80px)",
        ...r === "large" && {
          minHeight: e !== "auto" ? "calc(100vh - 80px)" : "auto"
        }
      },
      ...t && {
        width: "100vw",
        maxWidth: `calc(100vw - ${a.spacing(10)})`,
        height: "100vh",
        maxHeight: `calc(100vh - ${a.spacing(10)})`,
        margin: a.spacing(5),
        borderRadius: a.spacing(1)
      },
      ...e && {
        height: e,
        minHeight: e
      },
      ...n && {
        width: n
      },
      [a.breakpoints.down("sm")]: {
        position: "absolute",
        width: "100%",
        maxWidth: "100%",
        height: "100vh",
        maxHeight: "100vh",
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        margin: 0,
        borderRadius: 0,
        ...e && {
          top: "auto",
          borderRadius: a.spacing(1, 1, 0, 0),
          height: e,
          minHeight: e
        }
      },
      // Special case for Dialogs wrapped in Form
      ...o && {
        maxHeight: `calc(100vh - ${a.spacing(10)})`,
        form: {
          flex: 1,
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          overflow: "hidden",
          ...st[r],
          maxWidth: "100%",
          ...t && {
            width: "100%",
            maxWidth: "100%",
            height: "100%",
            maxHeight: "100%"
          },
          ...e && {
            height: e,
            minHeight: e
          },
          ...n && {
            width: n
          },
          [a.breakpoints.down("sm")]: {
            width: "100%",
            maxWidth: "100%",
            height: "100vh",
            maxHeight: "100vh",
            ...e && {
              top: "auto",
              borderRadius: a.spacing(1, 1, 0, 0),
              height: e,
              minHeight: e
            }
          }
        }
      }
    }
  })
);
function $o({
  nonModal: t,
  children: e,
  size: n = "small",
  PaperProps: o,
  fullScreen: r,
  height: a,
  width: l,
  hasForm: c,
  "aria-label": s,
  "data-testid": d,
  ...h
}) {
  return t ? /* @__PURE__ */ i(
    dt,
    {
      size: n,
      fullScreen: r,
      height: a,
      width: l,
      hasForm: c,
      "aria-label": s,
      "data-testid": d,
      ...h,
      children: e
    }
  ) : /* @__PURE__ */ i(
    ne,
    {
      PaperComponent: dt,
      PaperProps: {
        ...o,
        size: n,
        fullScreen: r,
        height: a,
        width: l,
        hasForm: c
      },
      fullScreen: r,
      role: "section",
      "aria-label": s,
      "data-testid": d,
      "data-size": n,
      "data-width": l,
      "data-height": a,
      ...h,
      children: e
    }
  );
}
const Rn = p(oe)(() => ({
  padding: 0,
  zIndex: 10
})), Fn = p(v)(({ theme: t }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: t.spacing(2),
  minHeight: t.spacing(8)
})), ut = p(v)(({ theme: t }) => ({
  display: "flex",
  alignItems: "center",
  gap: t.spacing(1),
  overflow: "hidden"
})), On = p(Mt)(({ theme: t }) => ({
  color: t.palette.text.secondary
})), Ln = p(G)(() => ({
  "+ .MuiDialogContent-root": {
    borderTop: "none !important"
  }
}));
function Ro({
  title: t,
  chipLabel: e,
  chipProps: n,
  children: o,
  onClose: r,
  secondaryActions: a,
  "aria-label": l,
  closeIcon: c,
  ...s
}) {
  const d = R(), h = $(d);
  return /* @__PURE__ */ x(j, { children: [
    /* @__PURE__ */ x(Rn, { component: "div", ...s, children: [
      /* @__PURE__ */ x(Fn, { children: [
        /* @__PURE__ */ x(ut, { flex: 1, maxWidth: 0.8, children: [
          /* @__PURE__ */ i(
            B,
            {
              component: "h2",
              variant: "inherit",
              noWrap: !0,
              "aria-label": l,
              children: t
            }
          ),
          e && /* @__PURE__ */ i(ie, { color: "default", label: e, ...n })
        ] }),
        /* @__PURE__ */ x(ut, { children: [
          a,
          r && /* @__PURE__ */ i(
            W,
            {
              title: h.formatMessage({ id: "c4r.button.close" }),
              placement: "left",
              children: /* @__PURE__ */ i(O, { onClick: r, children: c || /* @__PURE__ */ i(On, { "data-testid": "CloseIcon" }) })
            }
          )
        ] })
      ] }),
      o
    ] }),
    o && /* @__PURE__ */ i(Ln, {})
  ] });
}
const Wn = p(re, {
  shouldForwardProp: (t) => !["scrollableContent", "withGutter", "withBottomGutter"].includes(t)
})(({ theme: t, scrollableContent: e, withGutter: n, withBottomGutter: o }) => ({
  display: "flex",
  flexDirection: "column",
  gap: t.spacing(3),
  padding: 0,
  ...t.typography.body2,
  color: t.palette.text.secondary,
  ".MuiAlert-root": {
    minHeight: "auto"
  },
  ...e && {
    borderBottom: `1px solid ${t.palette.divider}`,
    "+ .MuiDivider-root": {
      display: "none"
    }
  },
  ...n && {
    padding: ` ${t.spacing(1, 2, 0)} !important`,
    ".MuiDialog-paperFullScreen &": {
      padding: `${t.spacing(2, 2, 0)} !important`
    }
  },
  ...o && {
    paddingBottom: `${t.spacing(3)} !important`,
    ".MuiDialog-paperFullScreen &": {
      paddingBottom: `${t.spacing(3)} !important`
    }
  }
}));
function En({
  children: t,
  scrollableContent: e,
  hasFooterAlert: n,
  withGutter: o = !0,
  withBottomGutter: r = !0,
  onScroll: a,
  ...l
}, c) {
  const s = V(), [d, h] = T(null);
  Lt(
    c,
    () => d,
    [d]
  );
  const u = nt(
    (f) => {
      const m = Math.abs(f.scrollHeight - f.clientHeight - f.scrollTop) < 1, y = f.scrollTop === 0, b = `1px solid ${s.palette.divider}`;
      f.style.borderTop = y ? "none" : b, f.style.borderBottom = m && !n ? "none" : b;
    },
    [s.palette.divider, n]
  ), g = nt(
    (f) => {
      u(f.target), a == null || a(f);
    },
    [u, a]
  );
  return H(() => {
    d && u(d);
  }, [d, u]), H(() => {
    if (!d || typeof ResizeObserver > "u") return;
    const f = new ResizeObserver(() => {
      u(d);
    });
    return f.observe(d), () => f.disconnect();
  }, [d, u]), /* @__PURE__ */ i(
    Wn,
    {
      ref: h,
      onScroll: g,
      scrollableContent: e,
      withGutter: o,
      withBottomGutter: r && o,
      ...l,
      children: t
    }
  );
}
const Hn = L(En), Fo = p(Hn, {
  shouldForwardProp: (t) => t !== "withAlert"
})(({ withAlert: t, theme: e }) => ({
  padding: `${e.spacing(0, 2)} !important`,
  ...t && {
    paddingBottom: `${e.spacing(3)} !important`
  }
})), _n = p(Ct)(({ theme: t }) => ({
  minHeight: "auto",
  padding: 0,
  backgroundColor: "transparent",
  "& .MuiTypography-root": {
    color: t.palette.text.secondary,
    a: {
      color: t.palette.primary.main
    }
  },
  "& .MuiAlertTitle-root": {
    color: t.palette.text.primary
  }
}));
function Rt({
  children: t,
  severity: e = "neutral",
  ...n
}) {
  return /* @__PURE__ */ i(_n, { severity: e, ...n, children: t });
}
const Pn = p(v, {
  shouldForwardProp: (t) => !["dark", "hasChildren"].includes(t)
})(({ dark: t, hasChildren: e, theme: n }) => ({
  flex: "0 0 auto",
  display: "block",
  minHeight: e ? n.spacing(8) : "auto",
  zIndex: 10,
  ...t && {
    backgroundColor: n.palette.common.black,
    color: n.palette.white[60],
    ".MuiAlert-root": {
      ".MuiTypography-root, .MuiAlert-message :not(.MuiAlertTitle-root)": {
        color: n.palette.white[60],
        a: {
          color: `${n.palette.secondary.main} !important`
        }
      },
      ".MuiAlert-icon": {
        color: n.palette.white[60]
      }
    }
  }
})), Gn = p(v)(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  "& > div:empty": {
    padding: 0
  }
})), jn = p(v, {
  shouldForwardProp: (t) => t !== "hasAlert"
})(({ hasAlert: t, theme: e }) => ({
  display: "flex",
  alignItems: "center",
  gap: e.spacing(1),
  padding: e.spacing(2),
  paddingTop: t ? 0 : e.spacing(2)
})), Ft = p(ae, {
  shouldForwardProp: (t) => t !== "hasAlert"
})(({ hasAlert: t, theme: e }) => ({
  gap: e.spacing(1),
  padding: e.spacing(2),
  paddingTop: t ? 0 : e.spacing(2),
  margin: 0,
  ".MuiButton-root + .MuiButton-root": {
    marginLeft: 0
  }
})), Vn = p(G)(() => ({
  // To prevent double border in the top when content is scrollable
  marginTop: "-1px"
}));
function Oo({
  children: t,
  secondaryActions: e,
  alertContent: n,
  alertProps: o,
  dark: r,
  topContent: a,
  ...l
}) {
  return /* @__PURE__ */ x(j, { children: [
    a,
    !!n && /* @__PURE__ */ i(Vn, {}),
    /* @__PURE__ */ x(
      Pn,
      {
        ...l,
        dark: r,
        "data-theme": r ? "dark" : "light",
        hasChildren: !!t,
        children: [
          !!n && /* @__PURE__ */ i(v, { sx: { p: 2, pt: 1.5, pb: 1 }, children: /* @__PURE__ */ i(Rt, { ...o, children: n }) }),
          /* @__PURE__ */ x(Gn, { children: [
            /* @__PURE__ */ i(jn, { hasAlert: !!n, children: e }),
            /* @__PURE__ */ i(Ft, { hasAlert: !!n, children: t })
          ] })
        ]
      }
    )
  ] });
}
const Nn = p(v)(({ theme: t }) => ({
  position: "absolute",
  width: "100%",
  zIndex: 100,
  top: 0,
  bottom: 0,
  left: 0,
  right: 0,
  overflow: "hidden",
  display: "flex",
  boxSizing: "border-box",
  alignItems: "flex-end",
  background: t.palette.white[60]
})), Un = p("div")(() => ({
  width: "100%"
})), Yn = p(v)(({ theme: t }) => ({
  width: "100%",
  padding: t.spacing(1.5, 2, 2),
  backgroundColor: t.palette.background.paper,
  borderTop: `1px solid ${t.palette.divider}`,
  ".MuiDialogActions-root": {
    padding: 0,
    marginTop: t.spacing(1)
  }
}));
function Lo({
  children: t,
  onClickAway: e,
  actions: n,
  severity: o = "warning",
  opened: r,
  "data-testid": a,
  "aria-label": l,
  ...c
}) {
  const s = U(null), d = V();
  return /* @__PURE__ */ i(
    Nn,
    {
      ref: s,
      "data-testid": a,
      "aria-label": l,
      role: "presentation",
      children: /* @__PURE__ */ i(xe, { onClickAway: () => {
        e && e();
      }, children: /* @__PURE__ */ i(
        xt,
        {
          direction: "up",
          in: r,
          container: s.current,
          mountOnEnter: !0,
          unmountOnExit: !0,
          easing: d.transitions.easing.easeOut,
          timeout: 350,
          children: /* @__PURE__ */ i(Un, { children: /* @__PURE__ */ x(Yn, { children: [
            /* @__PURE__ */ i(Rt, { severity: o, ...c, children: t }),
            /* @__PURE__ */ i(Ft, { children: n })
          ] }) })
        }
      ) })
    }
  );
}
const qn = p(v)(({ theme: t }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  height: t.spacing(8),
  marginBottom: t.spacing(2),
  "& > div": {
    flex: 1
  }
})), zn = p(v)(({ theme: t }) => ({
  display: "flex",
  flex: 1,
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  position: "relative",
  "&:before, &:after": {
    content: '""',
    background: t.palette.divider,
    position: "absolute",
    top: t.spacing(1.25),
    height: t.spacing(0.25),
    width: `calc(50% - ${t.spacing(2.5)})`
  },
  "&:before": {
    left: 0
  },
  "&:after": {
    right: 0
  },
  "&:first-of-type:before": {
    content: "none"
  },
  "&:last-of-type:after": {
    content: "none"
  }
}));
function Zn({
  theme: t,
  completed: e,
  current: n
}) {
  return e ? {
    background: t.palette.success.main,
    borderColor: t.palette.success.main,
    color: t.palette.common.white
  } : n ? {
    background: t.palette.text.primary,
    borderColor: t.palette.text.primary,
    color: t.palette.common.white
  } : {
    borderColor: t.palette.text.secondary,
    color: t.palette.text.secondary
  };
}
const Jn = p("span", {
  shouldForwardProp: (t) => t !== "completed" && t !== "current"
})(({ theme: t, completed: e, current: n }) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  height: t.spacing(3),
  width: t.spacing(3),
  marginBottom: t.spacing(1),
  borderRadius: "50%",
  border: `${t.spacing(0.25)} solid currentColor`,
  ...t.typography.caption,
  ...Zn({ theme: t, completed: e, current: n })
}));
function Wo({
  currentStep: t,
  stepsLabels: e,
  ...n
}) {
  return /* @__PURE__ */ i(qn, { ...n, children: /* @__PURE__ */ i(v, { sx: { display: "flex" }, children: e.map((o, r) => {
    const a = r + 1, l = a === t, c = a < t;
    return /* @__PURE__ */ x(
      zn,
      {
        "data-state": c ? "completed" : l ? "current" : "uncompleted",
        children: [
          /* @__PURE__ */ i(Jn, { completed: c, current: l, children: c ? /* @__PURE__ */ i(ge, { fontSize: "small", "aria-label": "Completed step" }) : a }),
          /* @__PURE__ */ i(B, { variant: "caption", component: "div", color: c ? "success.main" : l ? "textPrimary" : "textSecondary", children: o })
        ]
      },
      r
    );
  }) }) });
}
export {
  Do as AccordionGroup,
  Ct as Alert,
  Io as AppBar,
  Mo as Autocomplete,
  Ao as Avatar,
  go as Button,
  Co as CreatableAutocomplete,
  rt as DatePicker,
  wo as DateRangePicker,
  So as DateTimePicker,
  $o as Dialog,
  Ft as DialogActions,
  Rt as DialogAlert,
  Lo as DialogConfirmation,
  Hn as DialogContent,
  Fo as DialogContentPadded,
  Oo as DialogFooter,
  Ro as DialogHeader,
  dt as DialogPaper,
  Wo as DialogStepper,
  Le as IconButton,
  X as LabelWithIndicator,
  ho as Menu,
  Dt as MenuFilter,
  vt as MenuItem,
  bo as MenuList,
  vo as MultipleAutocomplete,
  xo as MultipleSelectField,
  fo as PasswordField,
  Te as SelectField,
  ko as Snackbar,
  _o as TablePaginationActions,
  Bo as TimePicker,
  mo as ToggleButtonGroup,
  To as TooltipData,
  B as Typography,
  yo as UploadField,
  ze as UploadFieldBase,
  st as dialogDimensionsBySize
};
